// Debounce
// https://redd.one/blog/debounce-vs-throttle
// If function is called several times in {duration},
// wait for a pause longer than {duration} to actually trigger it.
// eg, wait 500 milliseconds after last call to actually call doSomething():
// debounce(function () {
//    doSomething();
//  }, 500)

// -----------------------------------------------------------------------------
// CORRECTIF 29/07/2026 — boutons d'ajout inopérants sur la page d'accueil
//
// Les cartes produit rendues dans le bandeau héro n'ont pas de bloc d'ajout
// (le gabarit l'entoure d'un {% unless hero_banner %}). Or les fonctions
// ci-dessous parcourent TOUTES les cartes de la page portant la même variante
// et écrivaient directement dans .quantity__input, qui est absent sur ces
// cartes-là. Résultat : TypeError, et la requête cart/add.js placée après la
// boucle n'était jamais envoyée. Tout produit mis en avant dans le héro
// devenait donc impossible à ajouter depuis le reste de la page.
//
// Correction : on ignore les cartes dépourvues de bloc d'ajout, et dans les
// fonctions + / − l'appel serveur est sorti de la boucle (il était conditionné
// à index == 0, donc perdu si la carte du héro arrivait en première position).
// -----------------------------------------------------------------------------

function mmInitSplideTestimonials() {
    const id = ".mm-dc-testimonials";
    const splideElem = document.querySelector(id);

    if (splideElem) {
        new Splide(splideElem, {
            type: "splide",
            arrows: false,
            pagination: true,
            gap: 20,
            autoplay: true,
            rewind: true,
            interval: 4000,
            perPage: 1,
            padding: {
                right: "0",
                left: "0",
            },
        }).mount();
    }
}

document.addEventListener(
    "DOMContentLoaded",
    () => {
        mmInitSplideTestimonials();
    },
    { once: true }
);

function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

function mmCartSectionElement() {
    return document.getElementById("shopify-section-mm-cart");
}

function mmCartProductsContainerElement() {
    return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

function mmCartItem(productVariantId) {
    return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
    const itemEl = mmCartItem(productVariantId);

    return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(productVariantId) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);

    return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
    // Display qtty in front
    if (newQuantity >= 0) {
        const quantityEl = mmCartItemQuantityEl(productVariantId);

        quantityEl.dataset.itemQuantity = newQuantity;
        quantityEl.innerText = newQuantity;
    }
}

function mmCartHTMLFromData(data) {
    const el = document.createElement("DIV");
    el.innerHTML = data.sections["mm-cart"];

    return el;
}

function extractItemsFromCartHTML(data) {
    const el = mmCartHTMLFromData(data);
    return el.querySelector(".mm-dc-products-container");
}

function insertCartProductsFromResponse(data) {
    const itemsContainer = extractItemsFromCartHTML(data);
    mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

    return data;
}

function extractTotalPriceFromCartHTML(data) {
    const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
    return cartEl.querySelector("[data-cart-total-price]");
}

function insertInsertTotalPriceFromResponse(data) {
    const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
    const currentTotalPriceEl = mmCartSectionElement().querySelector("[data-cart-total-price]");
    currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;

    return data;
}

function mmAPIRequest(method, path, body) {
    document.querySelector(".mm-dc-products")?.classList?.add("mm-inactive");
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    })
        .then((response) => response.json())
        .then((data) => {
            document.querySelector(".mm-dc-products")?.classList?.remove("mm-inactive");
            if (data.status && data.status > 400) {
                throw data;
            } else {
                return data;
            }
        });
}

// récupérer le panier
function mmGetCart() {
    return mmAPIRequest("GET", "cart.js");
}

// Ouvrir le panier
function mmOpenCart() {
  mmGetCart();
  document.querySelector('.mm-drawer-cart-wrapper').classList.remove('mm-hidden');
}
function mmCloseCart() {
  document.querySelector('.mm-drawer-cart-wrapper').classList.add('mm-hidden');
}

// Ouvrir et refresh le panier (utilisé pour faire fonctionner les babybox et superbox avec le panier)
function mmOpenAndRefreshCart() {
    function handleResponse() {
        const newCartEl = document.createElement("DIV");
        newCartEl.innerHTML = this.responseText;
        const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-wrapper");
        innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-wrapper").innerHTML;
        document.querySelector(".mm-drawer-cart-wrapper").classList.add("mm-dc-is-open");
        document.querySelector("html").classList.add("stop-scrolling");
    }
    const request = new XMLHttpRequest();
    request.addEventListener("load", handleResponse);
    request.open("GET", "/?section_id=mm-cart", true);
    request.send();
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
    var lastStepElem = document.querySelector('.mm-dc-last-step');

    const newCartEl = document.createElement("DIV");
    newCartEl.innerHTML = data.sections["mm-cart"];

    if(lastStepElem.classList.contains('mm-visible')){
      newCartEl.querySelector('.mm-dc-last-step').classList.add('mm-visible')
    } else if (lastStepElem.classList.contains('mm-visible-mid')) {
      newCartEl.querySelector('.mm-dc-last-step').classList.add('mm-visible-mid')
    }

    // Header
    const newHeader = mmCartSectionElement().querySelector(".mm-dc-header");
    if(newHeader){
      newHeader.innerHTML = newCartEl.querySelector(".mm-dc-header").innerHTML;
    }

    // Products
    const newProducts = mmCartSectionElement().querySelector(".mm-dc-products-container");
    if(newProducts){
      newProducts.innerHTML = newCartEl.querySelector(".mm-dc-products-container").innerHTML;
    }

    // Bottom
    const newBottom = mmCartSectionElement().querySelector(".mm-dc-bottom");
    if(newBottom){
      newBottom.innerHTML = newCartEl.querySelector(".mm-dc-bottom").innerHTML;
    }

    // Last step
    const newLastStep = mmCartSectionElement().querySelector(".mm-dc-last-step");
    if(newLastStep){
      newLastStep.innerHTML = newCartEl.querySelector(".mm-dc-last-step").innerHTML;
    }

    // ProgressBar
    const ProgressBarInfo = mmCartSectionElement().querySelector(".mm-dc-free-product-progress-bar-info");
    const ProgressBarInner = mmCartSectionElement().querySelector(".mm-dc-free-product-progress-bar-inner");
    const ProgressBarInnerWhite = mmCartSectionElement().querySelector(".mm-dc-free-product-progress-bar-inner-text-filter");
    const ProgressBarContainer = mmCartSectionElement().querySelector(".mm-dc-free-product-progress-bar-container");
    if(ProgressBarInfo){
      ProgressBarInfo.innerHTML = newCartEl.querySelector(".mm-dc-free-product-progress-bar-info").innerHTML;
      ProgressBarInner.style.width = newCartEl.querySelector(".mm-dc-free-product-progress-bar-inner").style.width;
      ProgressBarInnerWhite.style.width = newCartEl.querySelector(".mm-dc-free-product-progress-bar-inner-text-filter").style.width;

      if(newCartEl.querySelector(".mm-dc-free-product-progress-bar-container").classList.contains('mm-dc-free-product-progress-bar-container-validated')){
        setTimeout(() => {
          ProgressBarContainer.classList.add('mm-dc-free-product-progress-bar-container-validated');
        }, "600");
      } else {
        ProgressBarContainer.classList.remove('mm-dc-free-product-progress-bar-container-validated');
      }
    }

    mmInitSplideTestimonials();

    // CART COUNT
	  updateCartCount(newCartEl.querySelector('[data-cart-count]').dataset.cartCount);

    // Cart total price modal product card
    updateModalTotalPrice(newCartEl.querySelector("[data-cart-total-price]").dataset.cartTotalPrice);


    return data;
}

// Ajouter un item au panier
function mmAddProductToCart(productId, quantity, openCart = true, showModal = false) {

  mmAPIRequest("POST", "cart/add.js", {
      items: [{ quantity: quantity, id: productId }],
      sections: "mm-cart",
  })
  .then(refreshCartFromData)
  .then(mmAddOrRemoveFreeProducts)
  .then((data) => {
      if (openCart) {
          setTimeout(mmOpenCart);
      }
  })
  .then((data) => {
    if (showModal) {
      mmShowModalProduct();
    }

  })
  .catch((error) => {
      mmCartProductsContainerElement().innerHTML = `
          Oups, il y a eu une erreur, essayez de recharger la page !
      `;
      mmOpenCart();
      console.log(error);
  });
}


function mmAddProductToCartProductCard(productId, { quantity = 1, openCart = true }) {
	const productCardElems = document.querySelectorAll(`.mm-product-card[data-variant-id="${productId}"]`);
	productCardElems.forEach(function(productCardElem, index){
		// Carte sans bloc d'ajout (bandeau héro) : rien à mettre à jour ici.
		const quantityEl = productCardElem.querySelector('.quantity__input');
		if (!quantityEl) return;

		let newQuantity = 1;
		quantityEl.innerText = newQuantity;
		const variantSelect = productCardElem.querySelector(".mm-pc-variants-selector-container select");
		if (variantSelect) {
			const selectedOption = variantSelect.options[variantSelect.selectedIndex];
			selectedOption.dataset.cartQtty = newQuantity;
		}

		// Change qtty selectors
		productCardElem.querySelector('.mm-quit-buy-container').classList.add('mm-styl-transition');

		productCardElem.querySelector('.mm-qb-btn-text').style.removeProperty('display');
		productCardElem.querySelector('.mm-pc-cta-container').style.display = 'none';
		productCardElem.querySelector('.mm-pc-delete-icon').style.removeProperty('display');
		productCardElem.querySelector('.mm-pc-minus-icon').style.display = 'none';
	})

    mmAPIRequest("POST", "cart/add.js", {
        items: [{ quantity: quantity, id: productId }],
        sections: "mm-cart",
    })
    .then(refreshCartFromData)
    .then(mmAddOrRemoveFreeProducts)
        .then((data) => {
            if (openCart) {
                setTimeout(mmOpenCart);
            }
        })
        .catch((error) => {
            mmCartProductsContainerElement().innerHTML = `
				Oups, il y a eu une erreur, essayez de recharger la page !
				`;
            mmOpenCart();
            console.log(error);
        });
}

function mmIncreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity + 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);

    const productCardElems = document.querySelectorAll(`.mm-product-card[data-variant-id="${productVariantId}"]`);

    productCardElems.forEach(function(productCardElem, index){
      const quantityEl = productCardElem.querySelector('.quantity__input');
      if (!quantityEl) return;

      quantityEl.innerText = newQuantity;
      const variantSelect = productCardElem.querySelector(".mm-pc-variants-selector-container select");
      if (variantSelect) {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        selectedOption.dataset.cartQtty = newQuantity;
      }

      // Change qtty selectors
      if (newQuantity == 0) {
        productCardElem.querySelector('.mm-quit-buy-container').classList.remove('mm-styl-transition');
        productCardElem.querySelector('.mm-pc-cta-container').style.removeProperty('display');
        productCardElem.querySelector('.mm-qb-btn-text').style.display = 'none';
      } else {
        productCardElem.querySelector('.mm-quit-buy-container').classList.add('mm-styl-transition');
        productCardElem.querySelector('.mm-qb-btn-text').style.removeProperty('display');
        productCardElem.querySelector('.mm-pc-cta-container').style.display = 'none';
        if (newQuantity == 1) {
          productCardElem.querySelector('.mm-pc-delete-icon').style.removeProperty('display');
          productCardElem.querySelector('.mm-pc-minus-icon').style.display = 'none';
        } else {
          productCardElem.querySelector('.mm-pc-minus-icon').style.removeProperty('display');
          productCardElem.querySelector('.mm-pc-delete-icon').style.display = 'none';
        }
      }
    })
}

function mmDecreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity - 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);

    const productCardElems = document.querySelectorAll(`.mm-product-card[data-variant-id="${productVariantId}"]`);

    productCardElems.forEach(function(productCardElem, index){
      const quantityEl = productCardElem.querySelector('.quantity__input');
      if (!quantityEl) return;

      quantityEl.innerText = newQuantity;
      const variantSelect = productCardElem.querySelector(".mm-pc-variants-selector-container select");
      if (variantSelect) {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        selectedOption.dataset.cartQtty = newQuantity;
      }

      // Change qtty selectors
      if (newQuantity == 0) {
        productCardElem.querySelector('.mm-quit-buy-container').classList.remove('mm-styl-transition');
        productCardElem.querySelector('.mm-pc-cta-container').style.removeProperty('display');
        productCardElem.querySelector('.mm-qb-btn-text').style.display = 'none';
      } else {
        productCardElem.querySelector('.mm-quit-buy-container').classList.add('mm-styl-transition');
        productCardElem.querySelector('.mm-qb-btn-text').style.removeProperty('display');
        productCardElem.querySelector('.mm-pc-cta-container').style.display = 'none';
        if (newQuantity == 1) {
          productCardElem.querySelector('.mm-pc-delete-icon').style.removeProperty('display');
          productCardElem.querySelector('.mm-pc-minus-icon').style.display = 'none';
        } else {
          productCardElem.querySelector('.mm-pc-minus-icon').style.removeProperty('display');
          productCardElem.querySelector('.mm-pc-delete-icon').style.display = 'none';
        }
      }
    })
}

function mmIncreaseProductQuantityProductCard(productVariantId) {
    const productCardElems = document.querySelectorAll(`.mm-product-card[data-variant-id="${productVariantId}"]`);
    let newQuantity = null;

    productCardElems.forEach(function(productCardElem, index){
      const quantityEl = productCardElem.querySelector('.quantity__input');
      if (!quantityEl) return;

      let quantity = parseInt(quantityEl.innerText);
      newQuantity = quantity + 1;
      quantityEl.innerText = newQuantity;
      const variantSelect = productCardElem.querySelector(".mm-pc-variants-selector-container select");
      if (variantSelect) {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        selectedOption.dataset.cartQtty = newQuantity;
      }

      // Change qtty selectors
      if (newQuantity == 0) {
        productCardElem.querySelector('.mm-quit-buy-container').classList.remove('mm-styl-transition');
        productCardElem.querySelector('.mm-pc-cta-container').style.removeProperty('display');
        productCardElem.querySelector('.mm-qb-btn-text').style.display = 'none';
      } else {
        productCardElem.querySelector('.mm-quit-buy-container').classList.add('mm-styl-transition');
        productCardElem.querySelector('.mm-qb-btn-text').style.removeProperty('display');
        productCardElem.querySelector('.mm-pc-cta-container').style.display = 'none';
        if (newQuantity == 1) {
          productCardElem.querySelector('.mm-pc-delete-icon').style.removeProperty('display');
          productCardElem.querySelector('.mm-pc-minus-icon').style.display = 'none';
        } else {
          productCardElem.querySelector('.mm-pc-minus-icon').style.removeProperty('display');
          productCardElem.querySelector('.mm-pc-delete-icon').style.display = 'none';
        }
      }
    })

    // Appel serveur sorti de la boucle : il était conditionné à index == 0 et
    // se perdait si la première carte trouvée était celle du bandeau héro.
    if (newQuantity !== null) {
      mmAPIRequest("POST", "cart/change.js", {
          id: productVariantId.toString(),
          quantity: newQuantity,
          sections: "mm-cart",
      })
      .then(mmAddOrRemoveFreeProducts)
      .then(refreshCartFromData)
      .then((data) => {
      })
    }
}

function mmDecreaseProductQuantityProductCard(productVariantId) {
    const productCardElems = document.querySelectorAll(`.mm-product-card[data-variant-id="${productVariantId}"]`);
    let newQuantity = null;

    productCardElems.forEach(function(productCardElem, index){
      const quantityEl = productCardElem.querySelector('.quantity__input');
      if (!quantityEl) return;

      let quantity = parseInt(quantityEl.innerText);
      newQuantity = quantity - 1;
      quantityEl.innerText = newQuantity;
      const variantSelect = productCardElem.querySelector(".mm-pc-variants-selector-container select");
      if (variantSelect) {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        selectedOption.dataset.cartQtty = newQuantity;
      }

      // Change qtty selectors
      if (newQuantity == 0) {
        productCardElem.querySelector('.mm-quit-buy-container').classList.remove('mm-styl-transition');
        productCardElem.querySelector('.mm-pc-cta-container').style.removeProperty('display');
        productCardElem.querySelector('.mm-qb-btn-text').style.display = 'none';

      } else {
        productCardElem.querySelector('.mm-qb-btn-text').style.removeProperty('display');
        productCardElem.querySelector('.mm-pc-cta-container').style.display = 'none';

        if (newQuantity == 1) {
          productCardElem.querySelector('.mm-pc-delete-icon').style.removeProperty('display');
          productCardElem.querySelector('.mm-pc-minus-icon').style.display = 'none';
        } else {
          productCardElem.querySelector('.mm-pc-minus-icon').style.removeProperty('display');
          productCardElem.querySelector('.mm-pc-delete-icon').style.display = 'none';
        }
      }
    })

    // Remove product — appel serveur sorti de la boucle (voir commentaire ci-dessus)
    if (newQuantity !== null) {
      mmAPIRequest("POST", "cart/change.js", {
          id: productVariantId.toString(),
          quantity: newQuantity,
          sections: "mm-cart",
      })
      .then(mmAddOrRemoveFreeProducts)
      .then(refreshCartFromData)
      .then((data) => {
      })
    }
}

function mmDestroyProductFromCart(productVariantId) {
    const newQuantity = 0;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmPushNewQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);

    mmAPIRequest("POST", "cart/change.js", {
        id: productVariantId.toString(),
        quantity: quantity,
        sections: "mm-cart",
    })
    .then(mmAddOrRemoveFreeProducts)
    .then(refreshCartFromData)
    .then((data) => {
    })
}

var mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
    // DISABLE PRODUCTS
    document.querySelector('.mm-dc-products').classList.add('mm-disabled');

    setTimeout(() => {
      mmPushNewQuantity(productVariantId);
    }, "0");
}, 300);

window.addEventListener("DOMContentLoaded", (event) => {
    mmGetCart();
});

function updateCartCount(value) {

  const basket = document.querySelector(".icon-basket");
  basket.classList.add("clicked");
    setTimeout(() => {
		basket.querySelector(".cart-count-bubble").innerText = `${value}`;
    }, 30);
  setTimeout(() => {
		basket.classList.remove("clicked");
  }, 500);


}

function updateModalTotalPrice(value) {
  const modalPrice = document.querySelector("#mm-pf-modal-cart-total-price");
  if (modalPrice) {
    var formattedPrice = value / 100;
    var euros = Math.floor(formattedPrice);
    var cents = Math.round((formattedPrice - euros) * 100);
    modalPrice.innerText = euros + "€" + (cents > 0 ? cents : "");
  }
}

function mmAddOrRemoveFreeProducts(data) {
    if (data.sections["mm-cart"]) {
        const el = mmCartHTMLFromData(data);
        const freeProductEls = el.querySelector("[data-free-products]");
        let freeProductCounts = 0;

        // creates an object like { 44058675: 1, 44058001: 0 }
        // where key is free product id and value, its quantity
        const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
            const productId = freeProductEl.dataset.variantId;
            const isFree = freeProductEl.dataset.freeProduct == "true";
            const itemEl = mmCartItem(productId);
            if (isFree) {
                freeProductCounts += 1;
            }
            if (itemEl && isFree) {
                 //console.log("do nothing, item is already added");
                // do nothing, item is already added
            } else if (itemEl && !isFree) {
                 //console.log("item is present but should be removed");
                // item is present but should be removed
                param[productId] = 0;
            } else if (!itemEl && isFree) {
                 //console.log("item is absent but should be added", productId);
                // item is absent but should be added
                param[productId] = 1;
            } else {
              //console.log('else')
            }
            return param;
        }, {});

        // Add or remove free products only if needed
        if (Object.keys(productsParams).length > 0) {
            mmAPIRequest("POST", "cart/update.js", { updates: productsParams, sections: "mm-cart" }).then(refreshCartFromData);
        }
    }
    return data;
}

// LAST STEP
function mmShowLastStep() {
  const productList = document.querySelector('.mm-dc-products-container');
  const lastStepElem = document.querySelector('.mm-dc-last-step');

  if (document.querySelector('.mm-dc-free-product-progress-bar-container')) {
    lastStepElem.classList.add('mm-visible-mid');
    productList.style.opacity = '0';
  } else if (document.querySelector('.mm-dc-free-product')) {
    lastStepElem.classList.add('mm-visible-mid');
    productList.style.opacity = '0';
  } else {
    lastStepElem.classList.add('mm-visible');
    productList.style.opacity = '0';
  }
}
function mmCloseLastStep() {
  const productList = document.querySelector('.mm-dc-products-container');
  const lastStepElem = document.querySelector('.mm-dc-last-step');

  lastStepElem.classList.remove('mm-visible');
  lastStepElem.classList.remove('mm-visible-mid');
  productList.style.opacity = '1';
}
